// extracted by mini-css-extract-plugin
module.exports = {"viewIcon":"expirationActionButtons_viewIcon__2Pgpl"};